import styled from 'styled-components';
import { Stack } from 'components/Stack';

export const DropOffDescriptionContainer = styled(Stack).attrs({
  direction: 'column',
  gap: 8,
})`
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
`;
